import React, { useEffect, useState } from 'react';
import Spinner from 'components/Spinner';
import API from 'helpers/API';
import { Route, Switch } from 'react-router';
import AuthRoute from 'routes/Auth/AuthRoute';
import resources from 'constants/resources';
import AddCustomEventType from './AddCustomEventType';
import EditCustomEventType from './EditCustomEventType';
import CustomEventTypesList from './CustomEventTypesList';
import CustomEventTypesContext from './CustomEventTypesContext';

function CustomEventTypes() {
  const [loading, setLoading] = useState(true);
  const [customEventTypes, setCustomEventTypes] = useState(null);
  const [shipmentFilters, setShipmentFilters] = useState(null);

  const loadData = async () => {
    setLoading(true);
    const { customEventTypes: loadedCustomEventTypes } = await API.getCustomEventTypes();
    await API.getShipmentFilters().then((response) => {
      setShipmentFilters(response.shipment_filters);
    });
    setCustomEventTypes(loadedCustomEventTypes);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  if (loading) {
    return <Spinner />;
  }

  return (
    <CustomEventTypesContext.Provider value={{ customEventTypes, shipmentFilters, loadCustomEventTypes: loadData }}>
      <Switch>
        <AuthRoute path="/settings/custom-event-types/add" component={AddCustomEventType} resource={resources.customEventTypes.edit} />
        <AuthRoute path="/settings/custom-event-types/:id" component={EditCustomEventType} resource={resources.customEventTypes.edit} />
        <AuthRoute path="/settings/custom-event-types" component={CustomEventTypesList} resource={resources.customEventTypes.read} />
        <Route render={() => 'not found'} />
      </Switch>
    </CustomEventTypesContext.Provider>
  );
}

export default CustomEventTypes;
